<form [formGroup]="control">
  <div class="single-budget-view" *ngIf="!isQuantity && formType == 'multi'">
    <div class="form-inputs form-padding">
      <p class="paragraph-medium-regular">Percentage*</p>
      <input matInput class="normal-txtbox" min="0" [max]="calculatePercentageLeft()" type="number"
        formControlName="Percentage" step="0.1" [disabled]="isReadOnly" [readonly]="isReadOnly" />
    </div>
  </div>

  <div class="single-budget-view" *ngIf="isQuantity && formType == 'multi'">
    <div class="form-inputs form-padding">
      <p class="paragraph-medium-regular">Quantity*</p>
      <input
        *ngIf="budgetTypeControl?.value && (budgetTypeControl.value.id == 'Capital' ||budgetTypeControl.value.id == 'Capital AUC' ); else deciamlQuantity"
        matInput class="normal-txtbox" min="0" [max]="calculateQuantityLeft()" type="number" formControlName="Quantity"
        step="1" [disabled]="isReadOnly" [readonly]="isReadOnly" (keypress)="onQuantityKeyPress($event)" />
      <ng-template #deciamlQuantity>
        <input
          matInput class="normal-txtbox" min="0" [max]="calculateQuantityLeft()" type="number" formControlName="Quantity"
          step="1" [disabled]="isReadOnly" [readonly]="isReadOnly" />
      </ng-template>
    </div>
  </div>

  <div class="single-budget-view">
    <div class="form-inputs form-dropdown mt-4">
      <p class="paragraph-medium-regular">Budget Type*</p>
      <div class="budget-tooltip-block">
          <ng-select [items]="budgetTypedropDownOptions" appearance="outline" bindLabel="value" formControlName="BudgetType"
          [disabled]="isReadOnly" [readonly]="isReadOnly" dropdownPosition="bottom" (change)="onBudgetTypeChange($event)">
            <ng-template ng-option-tmp let-item="item">
            <div [tp]="BudgetTypeOptionDisableTemplate" tpClassName="custom-tooltip"
            [tpInteractive]="true"  [tpIsEnabled]="item.disabled ?? false">{{item.value}}</div>
            </ng-template>
        </ng-select>
        <ng-template #BudgetTypeOptionDisableTemplate>
          <div class="custom-tooltip">
            <p>
              You cannot select this option due to the following possible reasons:
            </p>
            
            <ol>
              <li>Combining Capital and Operating budgets in a single item is not permitted.</li>
              <li>Splitting Capital and Capital AUC budgets by percentage is not allowed.</li>
            </ol>
          </div>
        </ng-template>

          <ng-template #tooltipTemplateInfo>
            <div class="custom-tooltip">
              <p>
                <strong>Capital</strong>
                <br/>
                Purchase of assets (equipment, software, hardware, furniture & fittings,
                motor vehicles) with unit cost more or equal $6,000 and can be used more than
                one year. Excludes consumables.
                <br/>
                <br/>
                <strong>Capital AUC</strong>
                <br/>
                Asset under construction (e.g. renovation projects, system development)
                <br/>
                <br/>
                <strong>Operating</strong>
                <br/>
                Expenses related to day-to-day servicing, primarily costs of labour and
                consumables, small aprts replacements (per unit costg < $6,000), maintenance and
                repairs, insurance, training, license renewal, annual software upgrades, etc.
                <br/>
                <br/>
                <strong>Project</strong>
                <br/>
                Acquisition of materials and services required for the execution of the project.
                <br/>
                <br/>
                For further clarifications, please contact Finance.
              </p>
            </div>
          </ng-template>
          <mat-icon [tp]="tooltipTemplateInfo" 
          tpClassName="custom-tooltip" tpMaxWidth="500px" [tpInteractive]="true" tpPlacement="bottom">help</mat-icon>
      </div>
    </div>
  </div>
  <div class="single-budget-view" *ngIf="budgetTypeControl?.value && budgetTypeControl.value.id == 'Operating'">
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">Cost centre*</p>
      <ng-select [items]="costCentreDropDownOptions" appearance="outline" bindLabel="value" formControlName="CostCentre"
        [disabled]="isReadOnly" [readonly]="isReadOnly" (change)="onCostCentreChange()" />
    </div>
  </div>
  <div class="single-budget-view" *ngIf="budgetTypeControl?.value && budgetTypeControl.value.id == 'Capital'">
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">Fund Centre*</p>
      <ng-select [items]="fundCentreDropDownOptions" appearance="outline" bindLabel="value" formControlName="FundCentre"
        [disabled]="isReadOnly" [readonly]="isReadOnly" (change)="onFundCentreChange()" />
    </div>
  </div>
  <div class="single-budget-view" *ngIf="budgetTypeControl?.value && budgetTypeControl.value.id == 'Project'">
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">Project code*</p>
      <div style="display: flex;">
        <div [tp]="projectCodetooltipTemplate" tpClassName="custom-tooltip" tpMaxWidth="280px" [tpInteractive]="true"
          tpPlacement="right" style="display: flex; align-items: center;gap: 8px;" tpTrigger="mouseenter focus click">
          <ng-select id="projectCodeManualInput" [items]="projectCodeDropDownOptions" appearance="outline"
            bindLabel="value" formControlName="ProjectCode" (change)="onProjectCodeChange($event)" [disabled]="isReadOnly"
            (keydown)="addDropdownOption($event)" [searchFn]="searchOriginalDropdowns" [readonly]="isReadOnly"
            [notFoundText]="projectCodeHint"></ng-select>
  
          <mat-icon style="cursor: pointer;">help</mat-icon>
        </div>
      </div>
  
      <ng-template #projectCodetooltipTemplate>
        <div class="custom-tooltip">
          <p>
            If you are member of a project, you will be able to choose the project name from the dropdown.
          </p>
          <br />
          <p>
            If you do not, you may enter the exact project code and hit “Enter” to search for the result.
          </p>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="single-budget-view" *ngIf="
      budgetTypeControl?.value &&
      (budgetTypeControl.value.id == 'Project' ||
        budgetTypeControl.value.id == 'Capital AUC')
    ">
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">Project Budget*</p>
      <ng-select [items]="projectBudgetDropDownOptions" appearance="outline" bindLabel="value"
        formControlName="ProjectBudget" [disabled]="isReadOnly" [readonly]="isReadOnly"
        (change)="onProjectBudgetChange($event)" />
    </div>
  </div>
  <div class="single-budget-view" *ngIf="budgetTypeControl?.value && budgetTypeControl?.value.id!==''">
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">G/L account*</p>
      <ng-select [items]="glAccountDropDownOptions" appearance="outline" bindLabel="value" formControlName="GLAcc"
        [disabled]="isReadOnly" [readonly]="isReadOnly" (change)="onGLAccountChange(budgetTypeControl?.value.id)" />
    </div>
  </div>
  <div class="single-budget-view" *ngIf="budgetTypeControl?.value && budgetTypeControl.value.id == 'Operating'">
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">Order no.</p>
      <ng-select [items]="orderNumberDropDownOptions" appearance="outline" bindLabel="value" formControlName="OrderNo"
        [disabled]="isReadOnly" [readonly]="isReadOnly" />
    </div>
  </div>
  <div class="form-inputs form-input-modal"
    *ngIf="budgetTypeControl?.value && budgetTypeControl.value.id !== '' && budgetTypeControl.value.id != 'Project'">
    <p class="paragraph-medium-regular">Select the budget expenditure usage for this item *</p>
    <mat-button-toggle-group name="budgetExp" [formControl]="budgetExpenditureControl" [disabled]="isReadOnly">
      <mat-button-toggle *ngFor="let budgetExpenditureOption of budgetExpenditureOptions"
      [disabled]="budgetExpenditureOption.disabled" [value]="budgetExpenditureOption">
        {{budgetExpenditureOption.value}}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div class="form-inputs form-input-modal" *ngIf="
      budgetTypeControl?.value &&
      budgetTypeControl.value.id == 'Operating' &&
      budgetExpenditureControl.value &&
      budgetExpenditureControl.value.id
    ">
    <p class="paragraph-medium-regular">Select the budget frequency usage for this item *</p>
    <mat-button-toggle-group name="budgetFreq" [formControl]="budgetFrequencyControl" [disabled]="isReadOnly">
      <mat-button-toggle *ngFor="let budgetFrequencyOption of budgetFrequencyOptions"
        [value]="budgetFrequencyOption">{{budgetFrequencyOption.value}}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div style="padding-top:20px">
    <shared-alert [type]="alertType.Error" *ngIf="formType == 'multi' && showAlert">
      <p alert-content class="my-1">{{alertMessage}}</p>
    </shared-alert>
  </div>
  <div class="form-inputs sidenav-btns" *ngIf="formType == 'multi'">
    <app-button class="budgetBtn" [name]="ActionType" type="flat-button" tabindex='0' (keypress)="!isReadOnly && addBudget()"
      (click)="!isReadOnly && addBudget()"></app-button>
  </div>
  <div class="single-budget-view limit-width" *ngIf="shouldShowMultiBudgetFormProjectCompletionMessage && formType == 'multi'">
    <div class="form-inputs form-input-modal message-style">
        <div><mat-icon class="icon">warning</mat-icon>
          <span> {{projectCompletionMessage}} </span>
        </div>
    </div>
  </div>
</form>